<template>
  <div class="panel-loading-message">
    <div class="container">
      <div class="row">
        <div class="loading-message">
          <h2>We zoeken nu naar de 6 beste coaches voor jou!</h2>
          <div class="spinner-wrapper">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <h2 class="loading-message-top">Tip:</h2>
          <div class="loading-message-text">
            <p>Bij alle coaches van Coachfinder is het <strong>kennismakingsgesprek gratis</strong>!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoadingMessage'
}

</script>